
<script>
import vue2Dropzone from "vue2-dropzone";
import { vendorService, customerService,alertService,promoCodeService,productService,orderService } from "../../services";
import { required , requiredIf, email} from "vuelidate/lib/validators";
import config from "../../config";
import { error_message, success_message } from "../../Helper/helper";
import DropzonePopup from "../../components/widgets/dropzone-popup";
import { decimalNumber,NotZeroNumber } from "../../Helper/formValidation";
import Multiselect from "vue-multiselect";

export default {
    components: { vueDropzone: vue2Dropzone, DropzonePopup, vendorService, customerService,Multiselect,alertService,promoCodeService,productService,orderService},
    data() {
        return {
            checked: true,
            file1: null,
            tmpCategoryImage: "",
            url: null,
            config: config,
            business_type :"Private",
            is_contact : 1,
            timezones: "",
            isDisabled:false,
            isLoading:false,
            subProducts:[],
        	products:[],
            error: [],
            typeform: {
                user_role: "Private",
                user_name: "",
                last_name: "",
                email: "",
                mobile_number: "",
                password: "",
                city: "",
                street: "",
                apartment: "",
                street_no: "",
                postal_code: "",
                address: "",
                user_profile:"",
                name : "",
                hrb : "",
                vat : "",
                company_logo : "",
                person_first_name : "",
                person_last_name : "",
                person_phone : "",
                person_email : "",
                is_contact_person : "1",
                business_user_name: "",
                business_last_name: "",
                business_email: "",
                business_mobile_number: "",
                business_password: "",
                business_city: "",
                business_postal_code: "",
                notes: "",
                parking_place: 0,
                parking_note: "",
                status: 0,
                product: "",
            	sub_product: "",
            	b2b_customers: [{ product:"",sub_product:"",min_qty:1,price:"",subProducts: [] }],
            },
        };
    },
    validations: {
        typeform: {
            user_role: {
                required,
            },
            user_name: {
                required : requiredIf(function(form){
                    return this.business_type == 'Private';
                }),
            },
            last_name: {
                required : requiredIf(function(form){
                    return this.business_type == 'Private';
                }),
            },
            email: {
                required : requiredIf(function(form){
                    return this.business_type == 'Private';
                }),
                email
            },
            mobile_number: {
                required : requiredIf(function(form){
                    return this.business_type == 'Private';
                }),
            },
            password: {
                required : requiredIf(function(form){
                    return this.business_type == 'Private';
                }),
            },
            city: {
                required : requiredIf(function(form){
                    return this.business_type == 'Private';
                }),
            },
            // user_profile: {
            //     required : requiredIf(function(form){
            //         return this.business_type == 'Private';
            //     }),
            // },
            street: {
                required,
            },
            street_no: {
                required,
            }, 
            postal_code: {
                required : requiredIf(function(form){
                    return this.business_type == 'Private';
                }),
            },
            business_postal_code: {
                required : requiredIf(function(form){
                    return this.business_type == 'Business';
                }),
            },
            // parking_note: {
            //     required : requiredIf(function(form){
            //         return this.business_type == 'Business';
            //     }),
            // },
            business_user_name: {
                required : requiredIf(function(form){
                    return this.business_type == 'Business';
                }),
            },
            business_last_name: {
                required : requiredIf(function(form){
                    return this.business_type == 'Business';
                }),
            },
            business_email: {
               required : requiredIf(function(form){
                    return this.business_type == 'Business';
                }),
                email
            },
            business_mobile_number: {
                required : requiredIf(function(form){
                    return this.business_type == 'Business';
                }),
            },
            business_password: {
                required : requiredIf(function(form){
                    return this.business_type == 'Business';
                }),
            },
            business_city: {
                required : requiredIf(function(form){
                    return this.business_type == 'Business';
                }),
            },
            name: {
                required : requiredIf(function(form){
                    return this.business_type == 'Business';
                }),
            },
            hrb: {
                required : requiredIf(function(form){
                    return this.business_type == 'Business';
                }),
            },
            vat: {
                required : requiredIf(function(form){
                    return this.business_type == 'Business';
                }),
            },
            // company_logo: {
            //     required : requiredIf(function(form){
            //         return this.business_type == 'Business';
            //     }),
            // },
            person_first_name: {
                required : requiredIf(function(form){
                    return this.business_type == 'Business' && this.is_contact == '1';
                }),
            },
            person_last_name: {
                required : requiredIf(function(form){
                    return this.business_type == 'Business' && this.is_contact == '1';
                }),
            },
            person_phone: {
                required : requiredIf(function(form){
                    return this.business_type == 'Business' && this.is_contact == '1';
                }),
            }, 
            person_email: {
                required : requiredIf(function(form){
                    return this.business_type == 'Business' && this.is_contact == '1';
                }),
                email
            },
            b2b_customers: {
            	$each: {
                	product: {
                    	required: requiredIf(function (form) {
                        	return (
                            	(form.sub_product != "" || form.price != "")
                        	);
                    	}),
                	},
                	sub_product:{
                    	required: requiredIf(function (form) {
                        	return (
                            	(form.product != "" || form.price != "")
                        	);
                    	}),
                	},
                	min_qty: {
                    	required: requiredIf(function (form) {
                        	return (
                            	(form.product != "" || form.price != "")
                        	);
                    	}),
                	},
                	price: {
                    	required: requiredIf(function (form) {
                        	return (
                            	(form.product != "" || form.sub_product != "")
                        	);
                    	}),
                	},
            	},
        	},
        },
    },
    mounted(){
        //this.getLanguage();
        this.asyncFindProduct({search:""});
    	this.resetB2BCustomers();
    },
    watch: {
    	'typeform.b2b_customers': {
        	handler(newVal) {
            	if (!Array.isArray(newVal)) {
                	this.resetB2BCustomers();
            	}
        	},
        	deep: true  // Watch nested properties within typeform.b2b_customers
    	}
	},
    methods: {
        decimalNumber,
    	NotZeroNumber,
        vatNumber(e){   
            const floating = /^[A-Za-z0-9 ]+$/;
            let char = String.fromCharCode(e.keyCode);
            if (floating.test(char)) return true;
            else e.preventDefault();
        },
        alphabetic(e){   
            const floating = /^[A-Za-z ]+$/;
            let char = String.fromCharCode(e.keyCode);
            if (floating.test(char)) return true;
            else e.preventDefault();
        },
        hrbNumber(e){   
            const floating = /^[A-Za-z0-9-]+$/;
            let char = String.fromCharCode(e.keyCode);
            if (floating.test(char)) return true;
            else e.preventDefault();
        },
        contactNumber(evt) {
            let val1 = evt.target.value;
            if (!(evt.keyCode == 43 || (evt.keyCode >= 48 && evt.keyCode <= 57))) {
                evt.preventDefault();
            }
            let partlen = val1.split("+").length - 1;
            if (evt.keyCode == 43 && partlen > 0) {
                evt.preventDefault();
            } else if (evt.keyCode == 43 && (evt.target.selectionStart !== undefined && evt.target.selectionStart !== 0)) {
                evt.preventDefault();
            }
        },
        onRoleChange(){
            this.business_type = this.typeform.user_role;
            if(this.business_type == 'Private'){
                this.typeform = {
                    user_role: "Private",
                    user_name: "",
                    last_name: "",
                    email: "",
                    mobile_number: "",
                    password: "",
                    city: "",
                    street: "",
                    apartment: "",
                    street_no: "",
                    postal_code: "",
                    address: "",
                    user_profile:"",
                    notes:"",
                    status: 0,
                    parking_place: 0
                }
                this.$v.typeform.$reset();
            }else if(this.business_type == 'Business'){
                this.typeform = {
                    user_role: "Business",
                    business_user_name: "",
                    business_last_name: "",
                    business_email: "",
                    business_mobile_number: "",
                    business_password: "",
                    business_city: "",
                    street: "",
                    street_no: "",
                    apartment:"",
                    business_postal_code: "",
                    name : "",
                    hrb : "",
                    vat : "",
                    company_logo : "",
                    person_first_name : "",
                    person_last_name : "",
                    person_phone : "",
                    person_email : "",
                    is_contact_person : "1",
                    notes:"",
                    parking_note: "",
                    status: 0,
                    b2b_customers: {
                    	$each: {
                        	product: {
                            	required
                        	},
                        	sub_product:{
                            	required
                        	},
                        	min_qty: {
                            	required: requiredIf(function (form) {
                                	return (
                                    	(form.product != "" && form.price != "")
                                	);
                            	}),
                        	},
                        	price: {
                            	required: requiredIf(function (form) {
                                	return (
                                    	(form.product != "")
                                	);
                            	}),
                        	},
                    	},
                	},
                }
                this.$v.typeform.$reset();
            }
        },
        onStatusChange(){
            this.is_contact = this.typeform.is_contact_person;
        },
        getLanguage(){
            vendorService.getLanguage()
            .then(response => {
                this.timezones  = response.data.result.timezone;
            });
        },
        checkAlreadyexistsSubProduct(val,i){
            var id = val.id;

            var subProduct = [];
            if(id){
                var subProduct = this.typeform.b2b_customers.filter(function(elem) {
                if (elem.sub_product.id == id) return elem;
                });
            }
            this.error[i] = false;
            if(subProduct.length > 1){
                this.error[i] = true;
                return false;
            }
        },
        addCustomer(){
            this.$v.typeform.$touch();
            if (this.$v.typeform.$invalid) {
                setTimeout(()=>{
                    $('html, body').animate({
                        scrollTop: $(".is-invalid:first").offset().top-$('#page-topbar').height()-50
                    }, 200, function() {
                        $(".is-invalid:first").focus();
                    });
                },300);
                return;
            }
            else{
                var error = false
                this.error.forEach(ele => {
                    if(ele == true) {
                        error = true;
                        alert('Please select different product');
                        this.isDisabled = false;
                        return;
                    }
                });
                if(error){
                    this.isDisabled = false;
                    return false;
                }
                this.isDisabled = true;
                customerService.addCustomer(this.typeform).then((response) => {
                    if (response.data.code === 200) {
                        success_message(response.data.message);
                        this.$router.push({ name: "customer-list" });
                    } else {
                        error_message(response.data.message);
                    }
                    this.isDisabled = false;
                });
            }
        },
        asyncFindProduct(query) {
        	this.isLoading = true;
            console.log(this.isLoading);
        	productService
            	.getSearchProductByNameApi({query:""})
            	.then((response) => {
                    this.products = response.data.result.sort((a, b) => {
                        return a.item_name.localeCompare(b.item_name);
                    });
            	this.isLoading = false;
        	});
    	},
    	getSubProduct(product,index) {
        	var product_id = product.id;
        	// this.subProducts = [];
        	this.typeform.sub_product = "";
            this.typeform.b2b_customers[index].subProducts = [];
        	this.isLoading = true;
        	orderService
            	.getVariantByProduct({ product_id:product_id,customer_type: "Business"})
            	.then((response) => {
                this.typeform.b2b_customers[index].subProducts = response.data.result.sort((a, b) => {
                    return a.sub_product_name.localeCompare(b.sub_product_name);
                });
            	this.isLoading = false;
                this.$set(this.typeform.b2b_customers[index], "sub_product", "");
        	});
    	},
    	AddField() {
        	this.typeform.b2b_customers.push({ product: "", sub_product: "", min_qty: 1, price: "",subProducts: []});
    	},
    	remove_field(i) {
        	this.typeform.b2b_customers.splice(i, 1);
    	},
    	customLabel ({ sub_product_name, material }) {
        	if(sub_product_name == "" || sub_product_name == 'undefined') return false;
        	return `${sub_product_name} ( ${material} )`
    	},
    	resetB2BCustomers() {
            this.typeform.b2b_customers = [{ product: "", sub_product: "", min_qty: 1, price: "",subProducts: []}];
    	},
    },
};
</script>
<template>
    <form @submit.prevent="addCustomer">
        <!-- Business Type Info Start -->
        <div class="card">
            <div class="card-body">
                <h4 class="card-title">{{ trans.get('__JSON__.Business Type Info') }}</h4>
                <p class="card-title-desc"></p>
                <div class="row">
                    <div class="col-sm-6">
                        <div class="form-group" v-if="$auth.setting">
                            <select
                                name="user_role"
                                class="custom-select"
                                id="user_role"
                                v-model="$v.typeform.user_role.$model"
                                :class="{ 'is-invalid':$v.typeform.user_role.$error }"
                                @change="onRoleChange()"
                            >
                                <!-- <option value="">{{ trans.get('__JSON__.Select Section Design Type') }}</option> -->
                                <option value="Business">Business</option>
                                <option value="Private" selected>Private</option>
                            </select>
                            <div v-if="$v.typeform.user_role.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.user_role.required">{{ trans.get('__JSON__.Please select business type') }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Business Type Info End -->

        <!-- Private Start -->
        <div class="card" v-if="this.business_type == 'Private'">
            <div class="card-body">
                <h4 class="card-title">{{ trans.get('__JSON__.Private Customer') }}</h4>
                <p class="card-title-desc"></p>
                
                <div class="row">
                    <div class="col-sm-4">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.First Name')}}</label>
                            <input
                                id="user_name"
                                v-model="$v.typeform.user_name.$model"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.First Name')"
                                name="user_name"
                                :class="{ 'is-invalid': $v.typeform.user_name.$error }"
                            />
                            <div v-if="$v.typeform.user_name.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.user_name.required">{{ trans.get('__JSON__.Please enter first name') }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.Last Name')}}</label>
                            <input
                                id="last_name"
                                v-model="$v.typeform.last_name.$model"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Last Name')"
                                name="last_name"
                                :class="{ 'is-invalid': $v.typeform.last_name.$error }"
                            />
                            <div v-if="$v.typeform.last_name.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.last_name.required">{{ trans.get('__JSON__.Please enter last name') }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.Email')}}</label>
                            <input
                                id="email"
                                v-model="$v.typeform.email.$model"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Email')"
                                name="email"
                                :class="{ 'is-invalid': $v.typeform.email.$error }"
                            />
                            <div v-if="$v.typeform.email.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.email.required">{{ trans.get('__JSON__.Please enter email') }}</span>
                                <span v-if="!$v.typeform.email.email" v-cloak>{{ trans.get('__JSON__.This value should be a valid email') }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.Phone')}}</label>
                            <input
                                maxlength="12"
                                minlength="9"
                                id="mobile_number"
                                v-model="$v.typeform.mobile_number.$model"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Phone')"
                                name="mobile_number"
                                @keypress="contactNumber($event)"
                                :class="{ 'is-invalid': $v.typeform.mobile_number.$error }"
                            />
                            <div v-if="$v.typeform.mobile_number.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.mobile_number.required">{{ trans.get('__JSON__.Please enter contact number') }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.Password')}}</label>
                            <input
                                id="password"
                                v-model="$v.typeform.password.$model"
                                type="password"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Password')"
                                name="password"
                                :class="{ 'is-invalid': $v.typeform.password.$error }"
                            />
                            <div v-if="$v.typeform.password.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.password.required">{{ trans.get('__JSON__.Please enter password') }}</span>
                            </div>
                        </div>
                    </div>

                    <!-- <div class="col-sm-4">
                        <div class="form-group">
                            <label class="control-label required">{{ trans.get('__JSON__.Timezone') }}</label>
                            <select class="custom-select" v-model="$v.typeform.time_zone.$model" id="time_zone" name="time_zone" :class="{ 'is-invalid':$v.typeform.time_zone.$error }">
                                <option value="">{{trans.get('__JSON__.Select Timezone')}}</option>
                                <option v-for="(value, key) in timezones" :value="key" :key="key">{{ value }}</option>
                            </select>
                            <div v-if="$v.typeform.time_zone.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.time_zone.required">{{ trans.get('__JSON__.Please select timezone') }}</span>  
                            </div>
                        </div>
                    </div> -->

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label>{{ trans.trans('__JSON__.Floor')}}</label>
                            <input
                                maxlength="2"
                                minlength="1"
                                id="apartment"
                                v-model="typeform.apartment"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Floor')"
                                name="apartment"
                                @keypress="contactNumber($event)"
                            />
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.Street')}}</label>
                            <input
                                id="street"
                                v-model="$v.typeform.street.$model"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Street')"
                                name="street"
                                v-on:keypress="alphabetic($event,typeform.street)"
                                :class="{ 'is-invalid': $v.typeform.street.$error }"
                            />
                            <div v-if="$v.typeform.street.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.street.required">{{ trans.get('__JSON__.Please enter street name') }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.Street Number')}}</label>
                            <input
                                maxlength="11"
                                minlength="1"
                                id="street_no"
                                v-model="$v.typeform.street_no.$model"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Street Number')"
                               
                                name="street_no"
                                :class="{ 'is-invalid': $v.typeform.street_no.$error }"
                            />
                            <!--  @keypress="contactNumber($event)" -->
                            <div v-if="$v.typeform.street_no.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.street_no.required">{{ trans.get('__JSON__.Please enter street number') }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.Postal Code')}}</label>
                            <input
                                maxlength="5"
                                minlength="5"
                                id="postal_code"
                                v-model="$v.typeform.postal_code.$model"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Postal Code')"
                                name="postal_code"
                                @keypress="contactNumber($event)"
                                :class="{ 'is-invalid': $v.typeform.postal_code.$error }"
                            />
                            <div v-if="$v.typeform.postal_code.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.postal_code.required">{{ trans.get('__JSON__.Please enter postal code') }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.City')}}</label>
                            <input
                                id="city"
                                v-model="$v.typeform.city.$model"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.City')"
                                name="city"
                                :class="{ 'is-invalid': $v.typeform.city.$error }"
                                v-on:keypress="alphabetic($event,typeform.city)"
                            />
                            <div v-if="$v.typeform.city.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.city.required">{{ trans.get('__JSON__.City Name Error') }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-4 vendor-status">
                        <b-form-group id="input-group-2" :label="trans.get('__JSON__.Status')" label-for="Status" >
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="swtich-data">
                                        <label class="switch">
                                        <input
                                            type="checkbox"
                                            id="status"
                                            class="switch-on"
                                            name="status"
                                            v-model="typeform.status"
                                            true-value="0"
                                            false-value="1"
                                        />
                                        <div class="slider round">
                                            <span class="on">{{ trans.get('__JSON__.Active') }}</span>
                                            <span class="off">{{ trans.get('__JSON__.Inactive') }}</span>
                                        </div>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </b-form-group>
                    </div>

                    <div class="col-md-4 vendor-status" v-if="this.business_type == 'Private'">
                        <b-form-group id="input-group-2" :label="trans.get('__JSON__.Parking Place')" label-for="Parking Place" >
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="swtich-data">
                                        <label class="switch">
                                        <input
                                            type="checkbox"
                                            id="togBtn"
                                            class="switch-on"
                                            name="parking_place"
                                            v-model="typeform.parking_place"
                                            true-value="1"
                                            false-value="0"
                                        />
                                        <div class="slider round">
                                            <span class="on">{{ trans.get('__JSON__.Yes') }}</span>
                                            <span class="off">{{ trans.get('__JSON__.No') }}</span>
                                        </div>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </b-form-group>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label>{{ trans.trans('__JSON__.Message From Customer')}}</label>
                            <textarea
                                rows="5"
                                id="notes"
                                v-model="typeform.notes"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Message From Customer')"
                                name="notes"
                            ></textarea>
                        </div>
                    </div>
                    
                    <div class="col-sm-4">
                        <div class="form-group">
                            <label>{{ trans.trans('__JSON__.Profile Image')}}</label>
                            <dropzone-popup
                                v-model="typeform.user_profile"
                                type="file"
                                id="user_profile"
                                name="user_profile"
                                acceptedFiles=".jpeg,.jpg,.png"
                            />
                        </div>
                    </div>

                </div>
                <div class="row">
                    <div class="col-sm-6">
                        <button class="btn btn-primary mr-1 mt-3" :disabled="isDisabled">{{ trans.get('__JSON__.Add Customer') }}</button>
                        <b-button @click="$router.go(-1)" type="button" variant="secondary" class="mt-3">{{ trans.get('__JSON__.Cancel') }}</b-button>
                    </div>
                </div>
            </div>
        </div>
        <!-- Private End -->

        <!-- Business Start -->
        <div class="card" v-if="this.business_type == 'Business'">
            <div class="card-body">
                <h4 class="card-title">{{ trans.get('__JSON__.Company Details') }}</h4>
                <p class="card-title-desc"></p>
                
                <div class="row">

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.Company Name')}}</label>
                            <input
                                id="name"
                                v-model="$v.typeform.name.$model"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Company Name')"
                                name="name"
                                :class="{ 'is-invalid': $v.typeform.name.$error }"
                            />
                            <div v-if="$v.typeform.name.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.name.required">{{ trans.get('__JSON__.Please enter company name') }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.CEO First Name')}}</label>
                            <input
                                id="business_user_name"
                                v-model="$v.typeform.business_user_name.$model"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.CEO First Name')"
                                name="business_user_name"
                                :class="{ 'is-invalid': $v.typeform.business_user_name.$error }"
                            />
                            <div v-if="$v.typeform.business_user_name.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.business_user_name.required">{{ trans.get('__JSON__.Please enter ceo first name') }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.CEO Last Name')}}</label>
                            <input
                                id="business_last_name"
                                v-model="$v.typeform.business_last_name.$model"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.CEO Last Name')"
                                name="business_last_name"
                                :class="{ 'is-invalid': $v.typeform.business_last_name.$error }"
                            />
                            <div v-if="$v.typeform.business_last_name.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.business_last_name.required">{{ trans.get('__JSON__.Please enter ceo last name') }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.Email')}}</label>
                            <input
                                id="business_email"
                                v-model="$v.typeform.business_email.$model"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Email')"
                                name="business_email"
                                :class="{ 'is-invalid': $v.typeform.business_email.$error }"
                            />
                            <div v-if="$v.typeform.business_email.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.business_email.required">{{ trans.get('__JSON__.Please enter email') }}</span>
                                <span v-if="!$v.typeform.business_email.email" v-cloak>{{ trans.get('__JSON__.This value should be a valid email') }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.HRB')}}</label>
                            <input
                                minlength="5"
                                id="hrb"
                                v-model="$v.typeform.hrb.$model"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.HRB')"
                                name="hrb"
                                :class="{ 'is-invalid': $v.typeform.hrb.$error }"
                            />
                            <div v-if="$v.typeform.hrb.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.hrb.required">{{ trans.get('__JSON__.Please enter hrb') }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.Vat')}}</label>
                            <div class="input-group mb-2">
                                <div class="input-group-prepend">
                                    <div class="input-group-text h-100 cust-input">DE</div>
                                </div>
                                <input
                                    maxlength="13"
                                    id="vat"
                                    v-model="$v.typeform.vat.$model"
                                    type="text"
                                    class="form-control"
                                    :placeholder="trans.trans('__JSON__.Vat')"
                                    name="vat"
                                    v-on:keypress="vatNumber($event,typeform.vat)"
                                    :class="{ 'is-invalid': $v.typeform.vat.$error }"
                                />
                            </div>
                            <div v-if="$v.typeform.vat.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.vat.required">{{ trans.get('__JSON__.Please enter vat') }}</span>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
        <!-- Business End -->

        <!-- Company Address Start -->
        <div class="card" v-if="this.business_type == 'Business'">
            <div class="card-body">
                <h4 class="card-title">{{ trans.get('__JSON__.Company Address') }}</h4>
                <p class="card-title-desc"></p>
                
                <div class="row">

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.Phone')}}</label>
                            <input
                                maxlength="12"
                                minlength="9"
                                id="business_mobile_number"
                                v-model="$v.typeform.business_mobile_number.$model"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Phone')"
                                name="business_mobile_number"
                                @keypress="contactNumber($event)"
                                :class="{ 'is-invalid': $v.typeform.business_mobile_number.$error }"
                            />
                            <div v-if="$v.typeform.business_mobile_number.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.business_mobile_number.required">{{ trans.get('__JSON__.Please enter contact number') }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.Password')}}</label>
                            <input
                                id="business_password"
                                v-model="$v.typeform.business_password.$model"
                                type="password"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Password')"
                                name="business_password"
                                :class="{ 'is-invalid': $v.typeform.business_password.$error }"
                            />
                            <div v-if="$v.typeform.business_password.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.business_password.required">{{ trans.get('__JSON__.Please enter password') }}</span>
                            </div>
                        </div>
                    </div>
                    
                    <div class="col-sm-4">
                        <div class="form-group">
                            <label>{{ trans.trans('__JSON__.Floor')}}</label>
                            <input
                                maxlength="2"
                                minlength="1"
                                id="apartment"
                                v-model="typeform.apartment"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Floor')"
                                name="apartment"
                                @keypress="contactNumber($event)"
                            />
                        </div>
                    </div>
                    
                    <div class="col-sm-4">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.Street')}}</label>
                            <input
                                id="street"
                                v-model="$v.typeform.street.$model"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Street')"
                                name="street"
                                v-on:keypress="alphabetic($event,typeform.street)"
                                :class="{ 'is-invalid': $v.typeform.street.$error }"
                            />
                            <div v-if="$v.typeform.street.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.street.required">{{ trans.get('__JSON__.Please enter street name') }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.Street Number')}}</label>
                            <input
                                maxlength="11"
                                minlength="1"
                                id="street_no"
                                v-model="$v.typeform.street_no.$model"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Street Number')"
                                
                                name="street_no"
                                :class="{ 'is-invalid': $v.typeform.street_no.$error }"
                            />
                            <!-- @keypress="contactNumber($event)" -->
                            <div v-if="$v.typeform.street_no.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.street_no.required">{{ trans.get('__JSON__.Please enter street number') }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.Postal Code')}}</label>
                            <input
                                maxlength="5"
                                minlength="5"
                                id="business_postal_code"
                                v-model="$v.typeform.business_postal_code.$model"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Postal Code')"
                                name="business_postal_code"
                                @keypress="contactNumber($event)"
                                :class="{ 'is-invalid': $v.typeform.business_postal_code.$error }"
                            />
                            <div v-if="$v.typeform.business_postal_code.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.business_postal_code.required">{{ trans.get('__JSON__.Please enter postal code') }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.City')}}</label>
                            <input
                                id="business_city"
                                v-model="$v.typeform.business_city.$model"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.City')"
                                name="business_city"
                                :class="{ 'is-invalid': $v.typeform.business_city.$error }"
                                v-on:keypress="alphabetic($event,typeform.business_city)"
                            />
                            <div v-if="$v.typeform.business_city.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.business_city.required">{{ trans.get('__JSON__.City Name Error') }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-4 vendor-status">
                        <b-form-group id="input-group-2" :label="trans.get('__JSON__.Status')" label-for="Status" >
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="swtich-data">
                                        <label class="switch">
                                        <input
                                            type="checkbox"
                                            id="togBtn"
                                            class="switch-on"
                                            name="status"
                                            v-model="typeform.status"
                                            true-value="0"
                                            false-value="1"
                                        />
                                        <div class="slider round">
                                            <span class="on">{{ trans.get('__JSON__.Active') }}</span>
                                            <span class="off">{{ trans.get('__JSON__.Inactive') }}</span>
                                        </div>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </b-form-group>
                    </div>

                    <div class="col-sm-4">
                        <b-form-group id="input-group-2" :label="trans.get('__JSON__.Is Contact Person')" label-for="Is Contact Person" >
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="swtich-data">
                                        <label class="switch">
                                        <input
                                            type="checkbox"
                                            id="togBtn"
                                            class="switch-on"
                                            name="is_contact_person"
                                            v-model="typeform.is_contact_person"
                                            true-value="1"
                                            false-value="0"
                                            @change="onStatusChange"
                                        />
                                        <div class="slider round">
                                            <!--ADDED HTML -->
                                            <span class="on">{{ trans.get('__JSON__.Yes') }}</span>
                                            <span class="off">{{ trans.get('__JSON__.No') }}</span>
                                            <!--END-->
                                        </div>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </b-form-group>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label>{{ trans.trans('__JSON__.Company Logo')}}</label>
                            <dropzone-popup
                                v-model="typeform.company_logo"
                                type="file"
                                id="company_logo"
                                name="company_logo"
                                acceptedFiles=".jpeg,.jpg,.png"
                            />
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label>{{ trans.trans('__JSON__.Message From Customer')}}</label>
                            <textarea
                                rows="5"
                                v-model="typeform.notes"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Message From Customer')"
                                name="notes"
                            ></textarea>
                        </div>
                    </div>

                    <!-- <div class="col-sm-4">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.Parking Note')}}</label>
                            <textarea
                                rows="5"
                                id="parking_note"
                                v-model="$v.typeform.parking_note.$model"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Parking Note')"
                                name="parking_note"
                                :class="{ 'is-invalid': $v.typeform.parking_note.$error }"
                            ></textarea>
                            <div v-if="$v.typeform.parking_note.$error" class="invalid-feedback">
                                <span
                                    v-if="!$v.typeform.parking_note.required"
                                >{{ trans.get('__JSON__.Please enter parking note') }}.</span>
                            </div>
                        </div>
                    </div> -->
                
                </div>

                <div class="row" v-if="this.business_type == 'Business' && this.is_contact == 0">
                    <div class="col-sm-6">
                        <button class="btn btn-primary mr-1 mt-3" :disabled="isDisabled">{{ trans.get('__JSON__.Add Customer') }}</button>
                        <b-button @click="$router.go(-1)" type="button" variant="secondary" class="mt-3">{{ trans.get('__JSON__.Cancel') }}</b-button>
                    </div>
                </div>
            </div>
        </div>
        <!-- Company Address End -->

        <!-- Compant Start -->
        <div class="card" v-if="this.business_type == 'Business' && this.is_contact == 1">
            <div class="card-body">
                <h4 class="card-title">{{ trans.get('__JSON__.Contact Person') }}</h4>
                <p class="card-title-desc"></p>
                
                <div class="row">

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.First Name')}}</label>
                            <input
                                id="person_first_name"
                                v-model="$v.typeform.person_first_name.$model"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.First Name')"
                                name="person_first_name"
                                :class="{ 'is-invalid': $v.typeform.person_first_name.$error }"
                            />
                            <div v-if="$v.typeform.person_first_name.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.person_first_name.required">{{ trans.get('__JSON__.Please enter first name') }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.Last Name')}}</label>
                            <input
                                id="person_last_name"
                                v-model="$v.typeform.person_last_name.$model"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Last Name')"
                                name="person_last_name"
                                :class="{ 'is-invalid': $v.typeform.person_last_name.$error }"
                            />
                            <div v-if="$v.typeform.person_last_name.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.person_last_name.required">{{ trans.get('__JSON__.Please enter last name') }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.Phone')}}</label>
                            <input
                                maxlength="12"
                                minlength="9"
                                id="person_phone"
                                v-model="$v.typeform.person_phone.$model"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Phone')"
                                name="person_phone"
                                @keypress="contactNumber($event)"
                                :class="{ 'is-invalid': $v.typeform.person_phone.$error }"
                            />
                            <div v-if="$v.typeform.person_phone.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.person_phone.required">{{ trans.get('__JSON__.Please enter contact number') }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.Email')}}</label>
                            <input
                                id="person_email"
                                v-model="$v.typeform.person_email.$model"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Email')"
                                name="person_email"
                                :class="{ 'is-invalid': $v.typeform.person_email.$error }"
                            />
                            <div v-if="$v.typeform.person_email.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.person_email.required">{{ trans.get('__JSON__.Please enter email') }}</span>
                                <span v-if="!$v.typeform.person_email.email" v-cloak>{{ trans.get('__JSON__.This value should be a valid email') }}</span>
                            </div>
                        </div>
                    </div> 
                </div>
                <!-- <div class="row" v-if="this.business_type == 'Business' && this.is_contact == 1">
                    <div class="col-sm-6">
                        <button class="btn btn-primary mr-1 mt-3" :disabled="isDisabled">{{ trans.get('__JSON__.Add Customer') }}</button>
                        <router-link
                            :to="{name:'customer-list'}"
                        >
                            <b-button
                                type="button" 
                                variant="secondary" 
                                class="mt-3">
                                {{ trans.get('__JSON__.Cancel') }}
                            </b-button>
                        </router-link>                            
                    </div>
                </div> -->
            </div>
        </div>
        <!-- Business End -->

        <div class="card" v-if="this.business_type == 'Business' && this.is_contact == 1">
        	<div class="card-body">
          	<h4 class="card-title">
            	{{ trans.get("__JSON__.B2B Prices") }}
          	</h4>
            	<div class="row" v-for="(v, i) in $v.typeform.b2b_customers.$each.$iter" :key="i">
                	<div class="col-sm-6">
                    	<div class="form-group">
                    	<label>{{ trans.trans("__JSON__.Product") }}</label>
                    	<multiselect
                        	v-model="v.product.$model"
                        	id="product"
                        	label="item_name"
                        	track-by="id"
                        	:placeholder="trans.get('__JSON__.Type to Search Product')"
                        	open-direction="bottom"
                        	:options="products"
                        	:multiple="false"
                        	:searchable="true"
                        	:loading="isLoading"
                        	:internal-search="true"
                        	:close-on-select="true"
                        	:clear-on-select="true"
                        	:max-height="600"
                        	:show-no-results="true"
                        	:hide-selected="true"
                        	@search-change="asyncFindProduct"
                        	@select="(product) => getSubProduct(product, i)"
                            :class="{
                                'is-invalid': v.product.$error,
                            }"
                        	>
                        	<span
                        	slot="noResult"
                        	>{{ trans.get('__JSON__.Oops! No elements found. Consider changing the search query') }}.</span>
                    	</multiselect>
                        <div v-if="v.product.$error" class="form-error">
                            <span v-if="!v.product.required">{{
                                trans.get("__JSON__.Please select product")
                            }}</span>
                        </div>
                    	</div>
                	</div>
    
                	<div class="col-sm-6">
                	<div class="form-group">
                    	<label>{{ trans.trans("__JSON__.Sub Product") }}</label>
                    	<multiselect
                    	v-model="v.sub_product.$model"
                    	id="sub_product"
                    	label="sub_product_name"
                    	track-by="id"
                    	:placeholder="trans.get('__JSON__.Sub Product')"
                    	open-direction="bottom"
                    	:options="typeform.b2b_customers[i].subProducts"
                    	:multiple="false"
                    	:searchable="false"
                    	:loading="isLoading"
                    	:internal-search="false"
                    	:close-on-select="true"
                    	:clear-on-select="true"
                    	:max-height="600"
                    	:show-no-results="true"
                    	:hide-selected="true"
                    	:custom-label="customLabel"
                        :class="{
                            'is-invalid': v.sub_product.$error,
                        }"
                        @select="checkAlreadyexistsSubProduct($event,i)"
                    	>
                    	<span
                    	slot="noResult"
                    	>{{ trans.get('__JSON__.Oops! No elements found. Consider changing the search query') }}.</span>
                    	</multiselect>
                        <div v-if="error[i] == true">
                            <span class="error-msg">{{
                                trans.get("__JSON__.This sub product already selected")
                            }}</span>
                        </div>
                        <div v-if="v.sub_product.$error" class="form-error">
                            <span v-if="!v.sub_product.required">{{
                                trans.get("__JSON__.Please select SubProduct")
                            }}</span>
                        </div>
                	</div>
                	</div>


                	<div class="col-sm-2">
                	<div class="form-group">
                    	<label>{{ trans.trans("__JSON__.Min. Quantity") }}</label>
                    	<input
                    	maxlength="5"
                    	minlength="1"
                    	v-model="v.min_qty.$model"
                    	type="text"
                    	class="form-control"
                    	:placeholder="trans.trans('__JSON__.Min. Quantity')"
                    	name="min_qty[]"
                        :class="{
                            'is-invalid': v.min_qty.$error,
                        }"
                    	@keypress="NotZeroNumber($event,5)"
                    	/>
                	</div>
                    <div v-if="v.min_qty.$error" class="form-error">
                      <span v-if="!v.min_qty.required">{{
                        trans.get("__JSON__.Please add quantity")
                      }}</span>
                    </div>
                	</div>
                	<div class="col-sm-2">
                	<div class="form-group">
                    	<label>{{ trans.trans("__JSON__.Price") }}</label>
                    	<input
                    	maxlength="8"
                    	minlength="1"
                    	v-model="v.price.$model"
                    	type="text"
                    	class="form-control"
                    	:placeholder="trans.trans('__JSON__.Price')"
                    	name="price[]"
                    	@keypress="decimalNumber"
                        :class="{
                            'is-invalid': v.price.$error,
                        }"
                    	/>
                	</div>
                    <div v-if="v.price.$error" class="form-error">
                      <span v-if="!v.price.required">{{
                        trans.get("__JSON__.Please add price")
                      }}</span>
                    </div>
                	</div>
                	<div class="col-md-2">
                	<h6>&nbsp;</h6>
                	<button
                    	class="btn btn-primary btn-sm btn-rounded"
                    	@click.prevent="AddField()"
                	>
                    	+</button
                	>&nbsp;&nbsp;
                	<button
                    	class="btn btn-danger btn-sm btn-rounded"
                    	v-if="i != 0"
                    	@click.prevent="remove_field(i)"
                	>
                    	-
                	</button>
                	</div>
            	</div>
            	<div class="row" v-if="this.business_type == 'Business' && this.is_contact == 1">
                	<div class="col-sm-6">
                    	<button class="btn btn-primary mr-1 mt-3" :disabled="isDisabled">{{ trans.get('__JSON__.Add Customer') }}</button>
                    	<router-link
                        	:to="{name:'customer-list'}"
                    	>
                        	<b-button
                            	type="button"
                            	variant="secondary"
                            	class="mt-3">
                            	{{ trans.get('__JSON__.Cancel') }}
                        	</b-button>
                    	</router-link>                       	 
                	</div>
            	</div>
        	</div>
      	</div>

    </form>
</template>